<template>

    <div class="size">
      <div class="boxsize1">
        <div class="catalogue">
          <div class="catalogue1" id="catalogue1" @click="contract">客户信息</div>
          <div class="catalogue2" id="catalogue2" @click="prospectus">投资画像</div>
          <div>
            <div>
              <span class="leftcss">姓名：</span>
              <span class="rightcss">{{userMassage.name}}</span>
              <span class="rightcss" v-if="level==1">
                  (<img src="../images/星形.png">)
              </span>
              <span class="rightcss" v-if="level==2">
                 (<img src="../images/星形.png"><img src="../images/星形.png">)
              </span>
              <span class="rightcss" v-if="level==3">
                <!-- <div class="wyjiao"></div> -->
                 (<img src="../images/星形.png"><img src="../images/星形.png"><img src="../images/星形.png">)
              </span>
            </div>
             <div>
              <span class="leftcss">手机号：</span>
              <span class="rightcss">{{userMassage.phone}}</span>
            </div>
             <div>
              <span class="leftcss">客户号：</span>
              <span class="rightcss">{{userMassage.customerId}}</span>
            </div>
             <div>
              <span class="leftcss">业务类型：</span>
              <span class="rightcss">{{businesstype}}</span>
            </div>
             <div>
              <span class="leftcss">开户行名称：</span>
              <span class="rightcss">{{userMassage.openBankName}}</span>
            </div>
            <div class="control">
                <div class="control2"  @click="goto"><img src="../images/编组47.png"  />小结</div>
                <div class="control4" @click="goto"><img src="../images/编组49.png"  />营销</div>
                <div class="control3" @click="goto"><img src="../images/编组51.png"  />提醒</div>
            </div>
          </div>
        </div>
      </div>

      <div class="boxsize1">
        <div class="catalogue">
          <div class="catalogue4" ><span class="titlecss">常用功能</span></div>
          <div>
            <div class="contro2">
                <div class="control2"  @click="goto"><img src="../images/编组59.png"  />截图</div>
                <div class="control4" @click="goto"><img src="../images/编组61.png"  />推送</div>
                <div class="control3" @click="goto"><img src="../images/编组63.png"  />聊天</div>
            </div>
            <div class="contro3">
                <div class="control2"  @click="goto"><img src="../images/编组73.png"  />图库管理</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'flow',
  mounted() {
    this.getCustIncomeMsg();
    this.getUserMessage();
  },
  mounted() {
    this.getUserMessage();
    	},
  data() {
    return {
      judge: true,
      bank: '中国工商银行股份有限公司',
      // name: "何婷婷",
      level: 3,
      // phone:15536775771,
      // customerID:20081738090,
      businesstype: '综合业务',
      // openbankname:"北京银行知春路分行",
      userMassage: {
        id: '',
        name: '',
        openBankname: '',
        phone: '',
        customerId: '',
      },
    };
  },
  methods: {

    getUserMessage() {
      const parames = {
        data: {
          phone: '15536775771',
        },
      };
      this.$_post(this.$API.getUserMassage, parames).then((res) => {
        if (res.errorCode == 'E00000') {
          console.log(res);
          this.userMassage = res.data.info;
          this.level = res.data.info.column2;
        }
      });
    },
    goto() {
      alert('暂未开放');
    },
    contract() {
      this.judge = true;
      this.switchover();
    },
    prospectus() {
      this.judge = false;
      this.switchover();
      this.$router.push({ path: '/rightvue2' });
    },
    switchover() {
      const a = document.getElementById('catalogue1');
      const b = document.getElementById('catalogue2');
      if (this.judge) {
        b.style.fontWeight = '500';
        a.style.fontWeight = 'bold';
        a.style.fontFamily = 'PingFangSC, PingFangSC-Medium';
        b.style.fontFamily = 'PingFangSC, PingFangSC-Light';
        a.style.borderBottom = '5px solid #000';
      } else {
        a.style.fontWeight = '500';
        b.style.fontWeight = 'bold';
        b.style.fontFamily = 'PingFangSC, PingFangSC-Medium';
        a.style.fontFamily = 'PingFangSC, PingFangSC-Light';
        a.style = ' border-bottom:1px solid ';
      }
    },
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.star{
  width: 12px;
  height: 12px;
  background: #fecd13;
}
.size{
  width: 290px;
  height: 678px;
  /* opacity: 0.5; */
  background: #f3f3f3;
}
.boxsize1{
  margin-left: 3px;
  width: 283px;
  height: 256px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
.bnt {
  width: 296px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.control {
  /* width: 283px; */
  height: 10rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.contro2 {
  width: 283px;
  height: 7rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.contro3 {
  width: 283px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  margin-left: 17px;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control3 {
  margin-right: 17px;
  font-size: 1rm;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control4 {
  /* margin-right: 17px; */
  font-size: 1rm;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 296px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
   width: 283px;
   height: 36px;
   background: #eeeeee;
   border-radius: 5px 5px 0px 0px;
}
.catalogue1{
    margin-left: 10px;
    width: 56px;
    height: 35px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #09254c;
    line-height: 35px;
    letter-spacing: 0px;
}
.catalogue2{
  margin-top: -35px;
  margin-left: 80px;
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 296;
  text-align: left;
  color: #09254c;
  line-height: 35px;
  letter-spacing: 0px;
}
.catalogue3{
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.catalogue4{
  margin-left: 105px;
  width: 56px;
  height: 35px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 35px;
  letter-spacing: 0px;
}
.text1{
   width: 296px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.fontcss2{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Light;
  font-weight: 296;
  text-align: left;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.titlecss{
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.leftcss{
  width: 48px;
  margin-left: 10px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  /* color: #666666; */
  line-height: 17px;
  letter-spacing: 0px;
}
.rightcss{
  width: 76px;
  margin-right: 10px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  /* color: #333333; */
  line-height: 17px;
  letter-spacing: 0px;
}
</style>
